import React from 'react';
import styled from 'styled-components';
import { LoadingSpinner } from '../../../elements/LoadingSpinner';
const LoadingWrapper = styled.div `
  position: absolute;
  top: ${({ $topOffset }) => ($topOffset ? `${$topOffset}px` : '40px')};
  left: 0;
  width: 100%;
  height: ${({ $topOffset }) => ($topOffset ? `calc(100% - ${$topOffset}px)` : '100%')};
  min-height: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity 0.2s ease;
  transition-delay: ${({ $isVisible }) => ($isVisible ? '0.6s' : '0s')};
  z-index: 2;
`;
export const LoadingOverlay = ({ isVisible, topOffset = 0 }) => {
    return (React.createElement(LoadingWrapper, { "$isVisible": isVisible, "$topOffset": topOffset },
        React.createElement(LoadingSpinner, null)));
};
//# sourceMappingURL=LoadingOverlay.js.map